/* tslint:disable */

declare var Object: any;
export interface TtadattendancetempInterface {
  "attenddata": string;
  "machineCode": string;
  "attendanceid"?: string;
  "attendDate": Date;
  "hour"?: number;
  "minute"?: number;
  "second"?: number;
  "day"?: number;
  "month"?: number;
  "year"?: number;
  "status"?: string;
  "machineno"?: string;
  "uploadstatus"?: number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "companyId": number;
  "remark"?: string;
  "photo"?: string;
  "geolocation"?: string;
  "attOn"?: number;
}

export class Ttadattendancetemp implements TtadattendancetempInterface {
  "attenddata": string;
  "machineCode": string;
  "attendanceid": string;
  "attendDate": Date;
  "hour": number;
  "minute": number;
  "second": number;
  "day": number;
  "month": number;
  "year": number;
  "status": string;
  "machineno": string;
  "uploadstatus": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "companyId": number;
  "remark": string;
  "photo": string;
  "geolocation": string;
  "attOn": number;
  constructor(data?: TtadattendancetempInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadattendancetemp`.
   */
  public static getModelName() {
    return "Ttadattendancetemp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadattendancetemp for dynamic purposes.
  **/
  public static factory(data: TtadattendancetempInterface): Ttadattendancetemp{
    return new Ttadattendancetemp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadattendancetemp',
      plural: 'Ttadattendancetemps',
      path: 'Ttadattendancetemps',
      properties: {
        "attenddata": {
          name: 'attenddata',
          type: 'string'
        },
        "machineCode": {
          name: 'machineCode',
          type: 'string'
        },
        "attendanceid": {
          name: 'attendanceid',
          type: 'string'
        },
        "attendDate": {
          name: 'attendDate',
          type: 'Date'
        },
        "hour": {
          name: 'hour',
          type: 'number'
        },
        "minute": {
          name: 'minute',
          type: 'number'
        },
        "second": {
          name: 'second',
          type: 'number'
        },
        "day": {
          name: 'day',
          type: 'number'
        },
        "month": {
          name: 'month',
          type: 'number'
        },
        "year": {
          name: 'year',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "machineno": {
          name: 'machineno',
          type: 'string'
        },
        "uploadstatus": {
          name: 'uploadstatus',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "photo": {
          name: 'photo',
          type: 'string'
        },
        "geolocation": {
          name: 'geolocation',
          type: 'string'
        },
        "attOn": {
          name: 'attOn',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadattendancetemp.ts